export default __webpack_public_path__ + "static/media/appstore-card.ca416f3e.png";